import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { useState, useEffect } from 'react';
import { displayAdsLog } from '../../../utils/debug';
import { publish } from '../../../podlet/events';

type GoogleReqData = {
    instanceId: string;
    query: string;
    position: string;
    targetElement: string;
    size: {
        width: number;
        height: number;
    };
};

export const setGoogleReqData = (event) => {
    displayAdsLog(`setGoogleReqData`);
    const payload = event.payload as GoogleReqData;

    const webComponent =
        document.querySelector('data-podlet-mlt') ||
        document.querySelector('data-podlet-recommend');
    displayAdsLog(`webComponent ${Boolean(webComponent)}`);

    const targetElement = webComponent.shadowRoot.getElementById(
        payload.targetElement,
    );

    displayAdsLog(`targetElement ${Boolean(targetElement)}`);

    displayAdsLog(`setGoogleReqData targetElement`);

    if (payload.instanceId && targetElement) {
        ReactDOM.render(
            <RecircGoogleAdReact googleRequestData={payload} />,
            targetElement,
        );
    }
};

const RecircGoogleAdReact = ({
    googleRequestData,
}: {
    googleRequestData: GoogleReqData;
}) => {
    displayAdsLog(`RecircGoogleAdReact render`);
    const [loaded, setLoaded] = useState(false);
    const [shouldFallback, setShouldFallback] = useState(false);

    useEffect(() => {
        if (!googleRequestData.instanceId) return;
        if (loaded) {
            // ensure a blink ad is never loaded twice, even in the edge case where the position changed
            return;
        }
        if (!('_googCsa' in window)) {
            setShouldFallback(true);
            return;
        }
        const pageOptions = {
            // @TODO get the final pubId's and styleId's
            pubId: 'vert-pla-scm-finn-no-pdp',
            styleId: 1050886310,
            query: googleRequestData.query,
            channel: 'feed',
            hl: 'no',
            adsafe: 'high',
            // We support click tracking even if we don't open links in new windows
            linkTarget: '_blank',
        };

        const afshBlock = {
            container: googleRequestData.instanceId,
            width: googleRequestData.size.width,
            height: googleRequestData.size.height,
            adLoadedCallback(containerName, adsLoaded) {
                displayAdsLog(
                    `recirc-google-ad: adLoadedCallback containerName: ${containerName} adsLoaded: ${adsLoaded}`,
                );
                if (adsLoaded) {
                    setLoaded(true);
                } else {
                    setShouldFallback(true);
                }
            },
            noAdLoadedCallback(containerName, _) {
                displayAdsLog(
                    `Loading Google ads failed for: ${containerName}`,
                );
                publish('recirc-google-ad', 'load-failed', true);
            },
        };

        window._googCsa('plas', pageOptions, afshBlock);
    }, [googleRequestData, loaded]);

    if (shouldFallback) return null;
    displayAdsLog(`RecircGoogleAdReact render ${googleRequestData.instanceId}`);
    return <div id={googleRequestData.instanceId || 'google-ad-placeholder'} />;
};

export default RecircGoogleAdReact;
